export {WEB_TOOLS_VERSION, WEB_TOOLS_BETA};

declare const __VERSION__: string;
declare const __BETA__: boolean;

const WEB_TOOLS_VERSION:string = __VERSION__;
const WEB_TOOLS_BETA:boolean = __BETA__;
